import React, { Component } from 'react';
import InputText from './InputText';
import { Select, DatePicker, message } from 'antd';
import { isEmpty, map, orderBy, find } from "lodash";
import * as yup from "yup";
import moment from "moment-timezone";
import chevron from '../../../Assets/images/chevron.svg';
import plus_icon from '../../../Assets/images/plus_icon.svg';
import Upload_Photo from '../../../Assets/images/Upload_Photo.svg';
import cross_icon from "../../../Assets/images/cross_icon.svg";
import { aboutUsData } from "../../../Assets/data/aboutUsList";
import axios from 'axios';
import config from '../../../Lib/config';
import AddressEntry from '../../Common/Addressentry';
const { Option } = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personal_info: {
        firstName: '',
        lastName: '',
        company: '',
        communityName: '',
        email: '',
      },
      registered_email: '',
      multiple_contact: [{ phone: '', type: 'mobile', primary: true }],
      single_contact: {},
      communityRole: '',
      preferredContact: [],
      communityType: [],
      communityHome: '',
      communityBoundaryMap: {},
      communityBoundaryMapUri: '',
      isProposal: false,
      proposalDate: '',
      isMoreInfo: false,
      address: {
        address: '',
        city: '',
        state: '',
        zip_code: '',
      },
      autocomplete: [],
      contactUs: [],
      is_continue_btn_active: false,
      loader: false,
      errors: {},
      is_address_manually: false,
      accountInfo: {},
      communityRoleData: [
        {
          id: 'board_member',
          name: 'Board Member',
          value: 'board_member'
        },
        {
          id: 'comm_manager',
          name: 'Community Manager',
          value: 'community_manager'
        },
        {
          id: 'conc_resident',
          name: 'Concerned Resident',
          value: 'concerned_resident'
        },
      ],
      preferredContactData: [
        {
          id: 'text',
          name: 'Text',
          value: 'text'
        },
        {
          id: 'home_phone',
          name: 'Home Phone',
          value: 'phone'
        },
        {
          id: 'email',
          name: 'Email',
          value: 'email'
        },
        {
          id: 'office',
          name: 'Office',
          value: 'office'
        },
        {
          id: 'mobile',
          name: 'Mobile',
          value: 'mobile'
        }
      ],
      communityTypeData: [
        {
          id: 'town_homes',
          name: 'Townhomes',
          value: 'townhomes'
        },
        {
          id: 'detached_homes',
          name: 'Detached Homes',
          value: 'detached'
        },
        {
          id: 'condominium',
          name: 'Condominium',
          value: 'condo'
        },
        {
          id: 'apartment',
          name: 'Apartment',
          value: 'apartment'
        },
      ],
      contactUsData: aboutUsData,
      is_new_email: false,
      registered_email: ''
    };
  }

  UNSAFE_componentWillMount = () => {
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    if (isEmpty(zipcode)) {
      this.props.history.push('/');
    }

    const temp = JSON.parse(sessionStorage.getItem('email'));
    let {personal_info} = this.state;

    Object.assign(personal_info, {email: temp ? temp : ''});
    this.setState({personal_info, registered_email: temp});

    const is_overwrite = JSON.parse(sessionStorage.getItem("is_lead"));
    const quote = JSON.parse(sessionStorage.getItem("quote"));
    const first_selected = sessionStorage.getItem('hear_about_us');

    if(first_selected !== null)
    {
      this.setState({contactUs: [first_selected]});
    }

    if(is_overwrite)
    {
      this.props.getQuoteById(quote);
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (Object.keys(nextProps?.AccountInfo?.data).length > 0 &&
      JSON.stringify(nextProps?.AccountInfo?.data) !== JSON.stringify(this.state.accountInfo)) {
      const userData = JSON.parse(localStorage.getItem("userKey"));

      if (!isEmpty(userData)) {
        const accountInfo = nextProps?.AccountInfo?.data;
        let multiple_contact = orderBy(accountInfo?.phone_numbers || [], 'primary', 'desc')
        multiple_contact = multiple_contact.map((x, i) => ({ ...x, primary: i === 0 }))
        let obj = {
          personal_info: {
            ...this.state.personal_info,
            firstName: accountInfo?.first_name || '',
            lastName: accountInfo?.last_name || '',
            email: accountInfo?.email || '',
          },
          multiple_contact: multiple_contact
        };
        this.setState({ accountInfo: nextProps?.AccountInfo?.data, ...obj })
      }
    }

    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && 
      JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }

    // Get hear about us
    if(Object.keys(nextProps?.quote_info).length > 0 && 
      JSON.stringify(nextProps?.quote_info) !== JSON.stringify(this.props?.quote_info))
    {
      if(Object.keys(this.state?.contactUs)?.length > 0 &&
      JSON.stringify(nextProps?.contactUs) !== JSON.stringify(this.props?.contactUs)) {
        this.setState({contactUs: [...this.state.hear_about_us, ...nextProps?.quote_info.hear_about_us]});
      }
      else {
        this.setState({contactUs: [...nextProps?.quote_info.hear_about_us]});
      }
    }
  }

  componentDidMount() {
    let step1Data = sessionStorage.getItem('commercialStep1');
    step1Data = step1Data && JSON.parse(step1Data);

    if (step1Data) {
      const {
        personal_info,
        address,
        communityRole,
        preferredContact,
        communityType,
        communityHome,
        communityBoundaryMap,
        communityBoundaryMapUri,
        contactUs,
        proposalDate,
        isProposal,
        isMoreInfo,
        multiple_contact,
        is_address_manually,
        is_new_email
      } = step1Data;

      this.setState({
        personal_info,
        address,
        communityRole,
        preferredContact,
        communityType,
        communityHome,
        communityBoundaryMap,
        communityBoundaryMapUri,
        contactUs,
        proposalDate,
        isProposal,
        isMoreInfo,
        multiple_contact,
        is_address_manually,
        is_new_email
      }, () => {
        if (!is_address_manually && this.refs['address']) {
          this.refs['address'].value = address?.address ? `${address?.address}, ${address?.city}, ${address?.state}, ${address?.zip_code}` : '';
        }
        // this.validate();
      });
    } else {
      // Get login user detail
      const userData = JSON.parse(localStorage.getItem("userKey"));
      if (!isEmpty(userData)) {
        this.props.getAccountInfo();
      }
    }
  }

  // multi value select
  onMultipleOptionChecked = (e, name) => {
    const { preferredContact, communityType, contactUs } = this.state;
    const data =
      name === 'preferredContact' ? preferredContact :
        name === 'communityType' ? communityType :
          name === 'contactUs' ? contactUs : [];
    const idx = data.indexOf(e.target.value);

    if (e.target.checked) {
      idx === -1 && data.push(e.target.value);
    } else {
      idx > -1 && data.splice(idx, 1);
    }
    this.setState({ [name]: data });
  };

  // object value change
  onObjectTextChanged = (e, name) => {
    const { address, personal_info } = this.state;
    let data = name === 'address' ? address : personal_info;
    Object.assign(data, { [e.target.name]: e.target.value });
    this.setState({ [name]: data });
  };

  // text value changed
  onTextChange = (e) => {
    const value = e.target.type === "file" ? e.target.files[0] : e.target.value;
    if (e.target.name === "isProposal") {
      this.setState({ isMoreInfo: false });
    } else if (e.target.name === "isMoreInfo") {
      this.setState({ isProposal: false });
    }
    this.setState({ [e.target.name]: value })
  };

  onCommunityImageChange = (e) => {
    let file = e?.target?.files?.[0];
    message.destroy();
    if (file?.type === 'application/pdf') {

      file && this.getBase64String(file, (result) => {
        this.setState({
          communityBoundaryMap: { name: file.name, size: file.size, type: file.type },
          communityBoundaryMapUri: result
        })
      })
    }
    else {
      message.error('Uploaded file is not a valid');
      this.setState({
        communityBoundaryMap: { name: '', size: '', type: '' },
        communityBoundaryMapUri: ''
      })
    }
  }

  updateAddress = (address) => {
    this.setState({ address });
  };

  // multiple contact change
  onContactNumberChange = (e, row = 0) => {
    const { value, name } = e.target;
    const { multiple_contact } = this.state;

    multiple_contact[row] = {
      ...multiple_contact[row],
      [name]: value
    };
    this.setState({ multiple_contact, single_contact: multiple_contact[row] });
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // add more contact
  addMoreContact = (e) => {
    e.preventDefault();
    const { multiple_contact } = this.state;
    // const id = multiple_contact.length + 1;
    this.setState((prevState) => ({ multiple_contact: [...prevState.multiple_contact, { phone: '', type: '' }] }));
  };

  // remove form multiple contact
  removeContact = (e, id) => {
    e.preventDefault();
    const { multiple_contact } = this.state;
    let tempContact = [...multiple_contact];
    const index = tempContact.indexOf(id);
    tempContact.splice(index, 1);
    this.setState({
      multiple_contact: tempContact
    })
  };

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        let postal_code = find(components?.address_components, (a) => {
          if (a.types.includes('postal_code')) {
            return a.short_name
          }
        });

        console.warn(`%c postal_code ${postal_code?.short_name}`, 'font-size: 12px; color: red')
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, {'address': item.short_name})
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, {'route': item.short_name})
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, {'street_number': item.short_name})
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, {'state': item.short_name})
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, {'city': item.long_name})
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, {'zip_code': item.short_name})
          }
        });
        this.setState({ address: obj }, () => {
          // const area = JSON.parse(sessionStorage.getItem('area'))
          //if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code || (obj.zip_code && obj.zip_code !== area?.zipcode)) {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address')
          }
          // this.validate()
        });
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // validate required values
  validate = () => {
    const {  address, is_address_manually } = this.state;
    const area = JSON.parse(sessionStorage.getItem('area'));
    const isAddress = !!address?.address;

    if (isAddress && !is_address_manually) {
      axios.post(`${config.getHost()}service-order/validate_address/`, {
        field_office_uuid: area && area.uuid,
        address: `${address?.address},${address?.city},${address?.state},${address?.zip_code}`
      }).then((response) => {
        if (Object.keys(response).length > 0 && response?.data?.is_valid) {
          this.setUp();
        } else {
          message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.', 10);
        }
      })
    } else {
      this.setUp();
    }
  };

  setUp = () => {
    const {
      address,
      communityRole,
      preferredContact,
      communityType,
      communityHome,
      communityBoundaryMapUri,
      communityBoundaryMap,
      contactUs,
      proposalDate,
      isProposal,
      isMoreInfo,
      multiple_contact,
      is_new_email,
      personal_info
    } = this.state;

    this.props.checkEmail(encodeURIComponent(this.state.personal_info?.email));

    const FILE_SIZE = 5 * 1048576;
    const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png", "application/pdf"];
    const schema = yup.object().shape({
      personal_info: yup.object().shape(
        {
          firstName: yup.string().required("First name is required"),
          lastName: yup.string().required("Last name is required"),
          email: yup.string().required("Email is required").matches(REGULAR_EXPRESSION_EMAIL, "Invalid Email Address"),
          communityName: yup.string().required('Community Name is required')
        }),
      communityBoundaryMap: yup.mixed().test("fileSize", "File too large", obj => {
        if (!isEmpty(obj)) return (obj.size <= FILE_SIZE)
        return true
      }).test("fileFormat", "Unsupported Format", obj => {
        if (!isEmpty(obj)) return (SUPPORTED_FORMATS.includes(obj.type))
        return true
      }),
      address: isProposal && proposalDate && yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup
          .string()
          .required("Zipcode is required")
          .min(5, "Your ZIP code is invalid.")
          .max(5, "Your ZIP code is invalid."),
      }),
    });

    const data = {
      personal_info,
      communityBoundaryMap,
      address
    }
    
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ is_continue_btn_active: true, errors: {} });
      this.props.onProceedToCheckout(true);
      
      // store step one data
      let obj = {
        personal_info,
        address: (address?.street_number || address?.route) ? { ...address, address: `${address?.street_number} ${address?.route}` } : address,
        communityRole,
        preferredContact,
        communityType,
        communityHome,
        communityBoundaryMap,
        communityBoundaryMapUri: communityBoundaryMapUri,
        contactUs,
        proposalDate,
        isProposal,
        isMoreInfo,
        multiple_contact,
        is_new_email
      };

      if (!is_new_email) {
        this.onContinue();
        sessionStorage.setItem('commercialStep1', JSON.stringify(obj));
        this.setState({ errors: {} });
      }
      else {
        message.error('Email address is already in use', 10);
      }
    }).catch((err) => {
      this.setState({ is_continue_btn_active: false });
      // sessionStorage.removeItem('commercialStep1');

      console.log(err);
      // this.props.onProceedToCheckout(false); // proceed to next step or not
      let err_data = {};
      map(err.inner, (item) => {
        err_data[item.path] = item.message;
      })
      this.setState({
        errors: err_data
      })
    })
  };

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // go to next step
  onContinue = () => {
    const { next } = this.props;
    const {
      personal_info,
      address,
      communityRole,
      preferredContact,
      communityType,
      communityHome,
      communityBoundaryMap,
      contactUs,
      proposalDate,
      isProposal,
      isMoreInfo,
      multiple_contact,
      communityBoundaryMapUri,
      is_address_manually
    } = this.state;

    let community_boundary_map = "";

    // get base64 format for boundary map
    this.setState({ loader: true });

    setTimeout(() => {
      let obj = {
        personal_info,
        address,
        communityRole,
        preferredContact,
        communityType,
        communityHome,
        communityBoundaryMap,
        communityBoundaryMapUri: community_boundary_map || communityBoundaryMapUri,
        contactUs,
        proposalDate,
        isProposal,
        isMoreInfo,
        multiple_contact,
        is_address_manually
      };

      sessionStorage.setItem('commercialStep1', JSON.stringify(obj));
      
      this.props.updateCustomerLastCompletedStep({
        step: 2,
        tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
      });
      
      this.setState({ loader: false, errors: {} });
      next && next(1);
    }, 500);
  };

  // render community role
  renderCommunityRole = (item, index) => {
    const { communityRole } = this.state;
    return (
      <label htmlFor={item.id} className={communityRole === item.value ? "area_box active_area_box" : "area_box"} key={`Role${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name='communityRole' className="custom--checkbox" value={item.value} onChange={(e) => this.onTextChange(e)} />
      </label>
    )
  };

  // render reach out via
  renderPreferredContact = (item, index) => {
    const { preferredContact,  multiple_contact} = this.state;
    const is_mobile_phone = multiple_contact?.filter(x => x.type === 'mobile')?.length > 0
    const is_home_phone = multiple_contact?.filter(x => x.type === 'home_phone')?.length > 0
    const is_office_phone = multiple_contact?.filter(x => x.type === 'office')?.length > 0

    const isSelected = preferredContact?.indexOf(item.value) > -1;
    if ((is_mobile_phone && item?.id === 'mobile') || (is_home_phone && item?.id === 'home_phone') || 
      (is_office_phone && item.id === 'office') || item.value === 'email' || (is_mobile_phone && item?.id === 'text')) {
      return (
        <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`Contact${index}`}>
          <span>{item.name}</span>
          <input type="checkbox" id={item.id} name='preferredContact' className="custom--checkbox" value={item.value} onChange={(e) => this.onMultipleOptionChecked(e, 'preferredContact')} />
        </label>
      )
    }
  };

  // render community type
  renderCommunityType = (item, index) => {
    const { communityType } = this.state;
    const isSelected = communityType?.indexOf(item.value) > -1;

    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`Type${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name='communityType' className="custom--checkbox" value={item.value} onChange={(e) => this.onMultipleOptionChecked(e, 'communityType')} />
      </label>
    )
  };

  //Render hear about us
  renderContactUs = (item, index) => {
    const { contactUs } = this.state;
    const isSelected = contactUs?.indexOf(item.value) > -1;

    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`Type${index}`}>
        <span>{item.name}</span>
        <input
          type="checkbox"
          id={item.id}
          name='contactUs'
          className="custom--checkbox"
          value={item.value}
          onChange={(e) => this.onMultipleOptionChecked(e, 'contactUs')}
        />
      </label>
    )
  };

  // Render single contact field
  renderContactField = (item, index) => {
    const userData = JSON.parse(localStorage.getItem("userKey"));
    return (
      <React.Fragment key={index}>
        <div className="billing_control phone_control">
          <div className="multi_control mr-2">
            <InputText
              disabled={userData ? true : false}
              style={{ opacity: userData ? '0.6' : '1' }}
              type="text"
              className='form--control mr-2'
              placeholder="Primary Number"
              name="phone"
              max="10"
              maxLength="10"
              onChange={(e) => { this.onNumericInputChange(e.target.value) && this.onContactNumberChange(e, index) }}
              value={item?.phone ? item?.phone : ''}
            />

          </div>
          <div className="multi_control mr-2 phone_number_type">
            <Select
              disabled={userData ? true : false}
              style={{ opacity: userData ? '0.6' : '1' }}
              placeholder="Type"
              suffixIcon={<img src={chevron} alt="" />}
              name="type"
              onChange={(value) => this.onContactNumberChange({ target: { name: 'type', value: value } }, index)}
              value={item?.type || undefined}
            >
              <Option value="home_phone">Home</Option>
              <Option value="mobile">Mobile</Option>
              <Option value="office">Office</Option>
            </Select>
          </div>
          {userData ? '' : <div className="multi_control add_more_contact">
            {
              index === 0 ?
                <a href='/#' onClick={(e) => {
                  this.addMoreContact(e)
                }}><img src={plus_icon} alt="" /></a> :
                <a href='/#' onClick={(e) => {
                  this.removeContact(e, index)
                }}><img src={cross_icon} alt="" /></a>
            }
          </div>}
        </div>
      </React.Fragment>
    )
  };

  render() {
    const {
      personal_info,
      address,
      multiple_contact,
      communityRoleData,
      preferredContactData,
      contactUsData,
      communityTypeData,
      communityHome,
      isMoreInfo,
      communityBoundaryMap,
      isProposal,
      loader,
      errors,
      is_address_manually,
      registered_email
    } = this.state;
    const { is_footer } = this.props;
    const userData = JSON.parse(localStorage.getItem("userKey"));

    return (
      <div className="commercial_form step1">
        <label className="back_arrow cursor_pointer" onClick={() => {
          sessionStorage.removeItem('commercialStep1')
          const currentUrl = window.location.href;
          const previousUrl = currentUrl.replace(/\/commercial$/, '/services');
          window.location.href = previousUrl;
        }}><i className="las la-arrow-left" />Back </label>

        <section className="billing_section mt-0">
          <div className="billing_form">
            <div className="billing_control">
              <div className="multi_control mr-2">
                <InputText
                  disabled={userData ? true : false}
                  style={{ opacity: userData ? '0.6' : '1' }}
                  type="text"
                  className='form--control'
                  placeholder="First Name"
                  name="firstName"
                  onChange={(e) => this.onObjectTextChanged(e, 'personal_info')}
                  value={personal_info?.firstName}
                />
                {errors['personal_info.firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['personal_info.firstName']}</label> : ''}
              </div>
              <div className="multi_control ">
                <InputText
                  disabled={userData ? true : false}
                  style={{ opacity: userData ? '0.6' : '1' }}
                  type="text"
                  className='form--control'
                  placeholder="Last Name"
                  name="lastName"
                  onChange={(e) => this.onObjectTextChanged(e, 'personal_info')}
                  value={personal_info?.lastName}
                />
                {errors['personal_info.lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['personal_info.lastName']}</label> : ''}
              </div>
            </div>
            <div className="billing_control sm-flex-col">
              <div className="multi_control mr-2">
                <InputText
                  type="text"
                  className='form--control'
                  placeholder="Management Company"
                  name="company"
                  onChange={(e) => this.onObjectTextChanged(e, 'personal_info')}
                  value={personal_info?.company}
                />
              </div>
              <div className="multi_control ">
                <InputText
                  type="text"
                  className='form--control'
                  placeholder="Community Name"
                  name="communityName"
                  onChange={(e) => this.onObjectTextChanged(e, 'personal_info')}
                  value={personal_info?.communityName}
                />
                {errors['personal_info.communityName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['personal_info.communityName']}</label> : ''}
              </div>
            </div>
            <div className="billing_control">
              <div className="single_control">
                <input
                  type="text"
                  disabled={userData || registered_email ? true : false}
                  style={{ opacity: userData ? '0.6' : '1' }}
                  className={registered_email ? 'disble_login_control form--control' : 'form--control'}
                  placeholder="Email Address"
                  name="email"
                  onChange={(e) => { this.onObjectTextChanged(e, 'personal_info'); }}
                  value={personal_info?.email || registered_email}
                  onBlur={() => {
                    this.props.checkEmail(encodeURIComponent(personal_info?.email));
                  }}
                />
                {errors['personal_info.email'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['personal_info.email']}</label> : ''}
              </div>
            </div>

            {
              map(multiple_contact, this.renderContactField)
            }
          </div>
        </section>
        <div className="preferred_contact">
          <span className="headlabel">What is your role in the community? <small>(select one)</small></span>
          <div className="contact_method_wrapper">
            {
              communityRoleData?.map(this.renderCommunityRole)
            }
          </div>
        </div>
        <div className="preferred_contact">
          <span className="headlabel">How would you like us to reach out to you? <small>(select all that apply)</small></span>
          <div className="contact_method_wrapper">
            {
              preferredContactData?.map(this.renderPreferredContact)
            }
          </div>
        </div>
        <hr />
        <div className="community-info">
          <h2 className="primary mb-20">Community information</h2>
          <div className="preferred_contact">
            <span className="headlabel">What is your community? <small>(select all that apply)</small></span>
            <div className="contact_method_wrapper">
              {
                communityTypeData?.map(this.renderCommunityType)
              }
            </div>
            <div className="form-group d-flex flex-col">
              <div className="multi_control select-box antselect mr-2">
                <Select
                  placeholder={is_footer ? "How many homes in the community?" : "How many homes are there in the community?"}
                  suffixIcon={<img src={chevron} alt="" />}
                  name="communityHome"
                  onChange={(value) => this.onTextChange({ target: { name: 'communityHome', value: value } })}
                  value={communityHome || undefined}
                  virtual={false}
                >
                  <Option value="1-100">1-100</Option>
                  <Option value="101-350">101-350</Option>
                  <Option value="351-500">351-500</Option>
                  <Option value="501+">501+</Option>
                </Select>
              </div>
              <div className={'multi_control'}>
                <div className="multi_control icofield">
                  <span className={communityBoundaryMap?.name ? 'selected' : 'placeholder'}>{communityBoundaryMap?.name || 'Community Map <5MB'}</span>
                  <input
                    type="file"
                    accept="application/pdf"
                    className="form--control ico-txt"
                    placeholder="Community Map <5MB"
                    name={'communityBoundaryMap'}
                    onChange={(e) => this.onCommunityImageChange(e)}
                  />
                  <img src={Upload_Photo} alt={""} />
                </div>
                {errors['communityBoundaryMap'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['communityBoundaryMap']}</label> : ''}
              </div>
            </div>
            <div className="form-group d-flex flex-col">
              <div className="checkbox_wrapper orange-check mr-4">
                <input
                  type="checkbox" id="c1"
                  checked={isProposal}
                  onChange={(e) => this.onTextChange({ target: { name: 'isProposal', value: e.target.checked } })} />
                <label htmlFor="c1" className="primary">I am looking for a Proposal</label>
              </div>

              <div className="checkbox_wrapper orange-check">
                <input
                  checked={isMoreInfo}
                  type="checkbox" id="c2"
                  onChange={(e) => this.onTextChange({ target: { name: 'isMoreInfo', value: e.target.checked } })} />
                <label htmlFor="c2" className="primary">I would like more information regarding this service</label>
              </div>
            </div>
            {
              isProposal &&
              <section className="preferred_date datebtn">
                <h4 className="primary mb-10">What date is your proposal due?</h4>

                <div className="date_list_wrapper">
                  <DatePicker
                    inputReadOnly
                    mode={'date'}
                    disabledDate={(current) => current && current <= moment()}
                    className='preferred_date_picker selected_date'
                    placeholder='Choose Date'
                    format={"ddd, MMM DD"}
                    dropdownClassName='current_month ch-date'
                    onChange={(e) => this.onTextChange({ target: { name: 'proposalDate', value: e.format('YYYY-MM-DD') } })}
                  />
                </div>
              </section>
            }
          </div>
        </div>
        {
          !isMoreInfo && isProposal &&
          <section className="service_address">
            <span className="headlabel">Sample address in this community</span>
            <AddressEntry
              id="google_address"
              address={address}
              onUpdateAddress={this.updateAddress} />
            {(errors['address.address'] || errors['address.city'] || errors['address.state'] || errors['address.zip_code'])
              ? <label className="new_err_msg"><i className="las la-info-circle" />{'Please enter valid address'}</label> : ''}
          </section>
        }

        <hr />
        <div className="preferred_contact">
          <h2 className="headlabel">How did you hear about us? <small>(select all that apply)</small></h2>
          <div className="contact_method_wrapper">
            {
              contactUsData?.map(this.renderContactUs)
            }
          </div>
        </div>
        <div className="btn-grp float-right p-0 col-md-6">
          <button
            type="button"
            className="btn btn--secondary lg-btn w-100"
            // disabled={!is_continue_btn_active}
            onClick={() => this.validate()}
          >Continue</button>
        </div>
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
      </div>
    );
  }
}

export default Step1;